import {Component, Input} from '@angular/core';
import {ITableColumn} from 'app/main/shared/shared/table/table-column';
import {ITableCellItem} from "../../../../../shared/shared/table/table-cell";
import {IDocumentDto} from "../../../dto/document-listing.dto";

@Component({
    selector: 'app-document-status',
    templateUrl: './document-status.component.html',
    styleUrl: './document-status.component.scss'
})
export class DocumentStatusComponent implements ITableCellItem {
    @Input() dataItem: IDocumentDto;
    @Input() columnOptions: ITableColumn;
}
